export default __webpack_public_path__ + "static/media/fa-solid-900.c6ec0800.woff";